<template>
  <div class="app-container">
    <div class="pad10">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
        <el-form label-width="100px" style="flex: 1;">
          <el-row>
            <el-col :span="8">
              <el-form-item label="当前状态:">
                <span v-if="data.OperatingStatus == 0">关机中</span>
                <span v-if="data.OperatingStatus == 1">待机中</span>
                <span v-if="data.OperatingStatus == 2">生产中</span>
                <span v-if="data.OperatingStatus == 3">故障中</span>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 2">
              <el-form-item label="生产订单号:">{{ operatingInfo.OrderNo }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 2">
              <el-form-item label="生产工单号:">{{ operatingInfo.WorkDocNo }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 2">
              <el-form-item label="生产产品:">{{ operatingInfo.ProductName }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 2">
              <el-form-item label="使用模具:">{{ operatingInfo.MouldNo }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 0 && operatingInfo.OperatingTime">
              <el-form-item label="最近关机时间:">{{ operatingInfo.OperatingTime }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 1 && operatingInfo.OperatingTime">
              <el-form-item label="最近开机时间:">{{ operatingInfo.OperatingTime }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 2 && operatingInfo.OperatingTime">
              <el-form-item label="最近生产时间:">{{ operatingInfo.OperatingTime }}</el-form-item>
            </el-col>
            <el-col :span="8" v-if="data.OperatingStatus == 3 && operatingInfo.OperatingTime">
              <el-form-item label="最近故障时间:">{{ operatingInfo.OperatingTime }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="auto-refresh-switch">
          <el-switch v-model="autoRefresh" active-text="自动刷新" inactive-text="" @change="onAutoRefreshChange"></el-switch>
          <span v-if="autoRefresh" class="refresh-tip">每20秒刷新</span>
        </div>
      </div>
      <el-tabs v-model="tabName" @tab-click="tabClick">
        <el-tab-pane label="实时数据" name="1"> <realtimedata ref="realtimedata"></realtimedata> </el-tab-pane>
        <el-tab-pane label="过程数据" name="2"> <processdata ref="processdata"></processdata> </el-tab-pane>
        <el-tab-pane label="工艺数据" name="3"> <craftdata ref="craftdata"></craftdata> </el-tab-pane>
        <el-tab-pane label="报警数据" name="4"> <warmdata ref="warmdata"></warmdata> </el-tab-pane>
        <el-tab-pane label="操作日志" name="5"> <oplogdata ref="oplogdata"></oplogdata> </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import craftdata from '@/components/facility/equipment/craftdata/list'
import processdata from '@/components/facility/equipment/processdata/list'
import realtimedata from '@/components/facility/equipment/realtimedata/list'
import warmdata from '@/components/facility/equipment/warmdata/list'
import oplogdata from '@/components/facility/equipment/oplogdata/list'
export default {
  name: 'equipmentList',
  components: { warmdata, realtimedata, processdata, craftdata, oplogdata },
  data() {
    return {
      data: { EquipmentId: null, OperatingStatus: null },
      api: require('@/api/ba/equipment').default,
      operatingInfo: { OperatingTime: null },
      tabName: '1',
      autoRefresh: false,
      refreshInterval: null
    }
  },
  mounted() {
    if (this.$route.params.mode == 'details') {
      this.data = this.$route.params.data
      this.getOperatingInfo(this.data.EquipmentId)
      if (this.tabName == '1') {
        this.$refs.realtimedata.getInfo(this.data.EquipmentId)
      }
    }
  },
  beforeDestroy() {
    this.stopAutoRefresh();
  },
  methods: {
    reshdata(){
      console.log(this.tabName, 'val')
      this.getOperatingInfo(this.data.EquipmentId)
      if (this.tabName == '1') {
        this.$refs.realtimedata.getInfo(this.data.EquipmentId)
      } else if (this.tabName  == '2') {
        this.$refs.processdata.getInfo(this.data.EquipmentId)
      } else if (this.tabName  == '3') {
        this.$refs.craftdata.getDatas(this.data.EquipmentId)
      } else if (this.tabName  == '4') {
        this.$refs.warmdata.getInfo(this.data.EquipmentId)
      } else if (this.tabName  == '5') {
        this.$refs.oplogdata.getDatas(this.data.EquipmentId)
      }
    },
    tabClick(val) {
      console.log(val, 'val')
      if (val.name == '1') {
        this.$refs.realtimedata.getInfo(this.data.EquipmentId)
      } else if (val.name == '2') {
        this.$refs.processdata.getInfo(this.data.EquipmentId)
      } else if (val.name == '3') {
        this.$refs.craftdata.getDatas(this.data.EquipmentId)
      } else if (val.name == '4') {
        this.$refs.warmdata.getInfo(this.data.EquipmentId)
      } else if (val.name == '5') {
        this.$refs.oplogdata.getDatas(this.data.EquipmentId)
      }
    },
    getOperatingInfo(id) {
      this.api.getOperatingInfo(id).then(res => {
        if (res.Code == 0) {
          this.operatingInfo = res.Data
          this.data.OperatingStatus=res.Data.OperatingStatus;
        }
      })
    },
    onAutoRefreshChange(val) {
      if (val) {
        this.startAutoRefresh();
      } else {
        this.stopAutoRefresh();
      }
    },
    startAutoRefresh() {
      this.stopAutoRefresh();
      this.refreshInterval = setInterval(this.reshdata, 1000 * 20);
    },
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    }
  }
}
</script>
<style scoped>
.pad10 {
  padding: 10px;
}
.auto-refresh-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  padding-left: 16px;
}
.refresh-tip {
  font-size: 12px;
  color: #909399;
}
</style>